import { ChevronDown } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { LegacyIconRenderer } from "../../helper/components/LegacyIconRenderer.js";
import { Progress } from "../progress/Progress.js";
import styles from "./List.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const List = ({
  children,
  collapsed,
  icon,
  title,
  subtitle,
  className,
  progress,
  onCollapse,
  disabled,
  ...forwardProps
}) => {
  const isCollapsable = typeof collapsed !== 'undefined';
  const isCollapsed = isCollapsable ? collapsed : false;
  const classes = classnames(styles.list, {
    [styles.collapsable]: isCollapsable,
    [styles.disabled]: disabled
  }, className);
  const hasIcon = !!icon;
  return /*#__PURE__*/_jsxs("ul", {
    ...forwardProps,
    className: classes,
    children: [title && /*#__PURE__*/_jsx("li", {
      className: styles.headerLi,
      children: /*#__PURE__*/_jsxs("button", {
        type: "button",
        onClick: onCollapse,
        tabIndex: isCollapsable ? 0 : -1,
        className: styles.header,
        disabled: disabled,
        children: [hasIcon && /*#__PURE__*/_jsx("span", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(LegacyIconRenderer, {
            icon: icon
          })
        }), typeof progress === 'number' && /*#__PURE__*/_jsx("span", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(Progress, {
            circular: true,
            value: progress
          })
        }), /*#__PURE__*/_jsxs("span", {
          className: styles.text,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.title,
            children: title
          }), subtitle && /*#__PURE__*/_jsx("span", {
            className: styles.subtitle,
            children: subtitle
          })]
        }), isCollapsable && /*#__PURE__*/_jsx("span", {
          className: styles.collapse,
          children: /*#__PURE__*/_jsx(ChevronDown, {
            className: classnames(styles.icon, isCollapsed ? styles.arrowDown : styles.arrowUp)
          })
        })]
      })
    }), !isCollapsed && children]
  });
};